import { GetAppName, BuildAppID } from 'cc-bu-util'

export const buildAppID: BuildAppID = (appName, reverseDomain) => `${reverseDomain}.${appName}`
export const getAppName: GetAppName = (reverseDomain, appId = '') => appId.replace(`${reverseDomain}.`, '')
